import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Lock, CreditCard, Flame } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-border/70 bg-background">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-3">
            <img src="/brand/fdl-logo.png" alt="Furnace Design Lab" className="h-12 w-auto drop-shadow-[0_0_20px_rgba(74,164,255,0.35)]" />
          </div>
          <p className="mt-3 max-w-xs text-sm text-muted-foreground">
            Press-ready halftones, AI vector cleanup and DTF/DTG prepress — all in your browser.
          </p>
          <div className="mt-4 flex flex-wrap items-center gap-2 text-[10px] uppercase tracking-widest text-muted-foreground">
            <span className="inline-flex items-center gap-1 rounded-full border border-border bg-card px-2 py-1"><Lock className="h-3 w-3 text-[#4aa4ff]" /> SSL secured</span>
            <span className="inline-flex items-center gap-1 rounded-full border border-border bg-card px-2 py-1"><CreditCard className="h-3 w-3 text-[#4aa4ff]" /> Stripe payments</span>
            <span className="inline-flex items-center gap-1 rounded-full border border-border bg-card px-2 py-1"><ShieldCheck className="h-3 w-3 text-[#4aa4ff]" /> PCI-DSS L1</span>
            <span className="inline-flex items-center gap-1 rounded-full border border-border bg-card px-2 py-1"><Flame className="h-3 w-3 text-[#f5c845]" /> 15-day refund</span>
          </div>
        </div>
        <div>
          <h4 className="mb-3 text-sm font-semibold">Product</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link className="hover:text-foreground" to="/studio/halftone">Halftone Studio</Link></li>
            <li><Link className="hover:text-foreground" to="/studio/vector">AI Vector Creator</Link></li>
            <li><Link className="hover:text-foreground" to="/studio/watermark">Watermark Remover</Link></li>
            <li><Link className="hover:text-foreground" to="/studio/upgrade">Photo Upgrader</Link></li>
            <li><Link className="hover:text-foreground" to="/pricing">Pricing</Link></li>
            <li><Link className="hover:text-foreground" to="/services">DTF services</Link></li>
            <li><Link className="hover:text-foreground" to="/redeem">Redeem code</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="mb-3 text-sm font-semibold">Learn</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link className="hover:text-foreground" to="/learn">Learn hub</Link></li>
            <li><Link className="hover:text-foreground" to="/learn/underbase-101">Underbase 101</Link></li>
            <li><Link className="hover:text-foreground" to="/learn/lpi-cheatsheet">LPI cheatsheet</Link></li>
            <li><Link className="hover:text-foreground" to="/learn/which-halftone-style">Style picker guide</Link></li>
            <li><Link className="hover:text-foreground" to="/learn/soft-hand-secrets">Soft-hand secrets</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="mb-3 text-sm font-semibold">Company</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link className="hover:text-foreground" to="/about">About us</Link></li>
            <li><Link className="hover:text-foreground" to="/contact">Contact</Link></li>
            <li><Link className="hover:text-foreground" to="/terms">Terms</Link></li>
            <li><Link className="hover:text-foreground" to="/privacy">Privacy</Link></li>
            <li><Link className="hover:text-foreground" to="/refund">Refund policy</Link></li>
            <li><Link className="hover:text-foreground" to="/admin">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-6 text-xs text-muted-foreground sm:flex-row sm:px-6">
          <div>© {new Date().getFullYear()} Furnace Design Lab. All rights reserved.</div>
          <div className="mono uppercase tracking-[0.18em]">forge · press · wear</div>
        </div>
      </div>
    </footer>
  );
}
